export { default } from './FaqAccordion'

export {
    StyledFaqContentStack,
    StyledFaqSubHeading,
    StyledFaqText,
} from './FaqAccordion.styled'
